export class Inventory {

    constructor(
		public item: string = '',
		public mfgr: string = '',
		public warehouse_id = null,
		public originCountry: string = '',
		public serialnumber: string = '',
		public originalunitcost: number = null,
		public condition_id = null,
		public customerAsset: string = '',
		public description: string = '',
		public status: string = '',
		public extendeddescription: any = '',
		public internalComments: string = '',
		public commentstovendor: string = '',
		public pp = null,
		public po = null,
		public sp = null,
		public so = null,

		public inventoryid: number = null,

		public logs: Array<any> = [],

		public poid: number = null,
		public quantity: number = null,
		public location: string = '',
		public idVirtualContainer: number = null,
		public condition = null,
		public warehouseTable = null,
		public container_id = null,
		public weightItem = null,
		public type: string = '',
		public testingStatus: string = '',
		public poline = null,
		public soLine = null,
		public warehouse_name = '',
		public po_line = '',
		public dateReceived = '',
		public purchaseCost = '',
		public so_line = '',
		public receivestatus = '',
		public weight = '',
		public inventorySystemComments = '',
		public soItiemInternalComments = '',
		public commentsToCustomeer = '',
		public commentsToVendor = '',
		public reservedBy = '',
		public datereserved = '',
		public returnedBy = '',
		public dateReturned = '',
		public poGroup = null,
		public id = null,
		public nonInventory: number = null,
		public unitprice: number = null,
		public datebooked = ''
	) {}
}